import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const multiProductBannerProductCardDefaultVariants = {}
const multiProductBannerProductCardCompoundVariants = []

const multiProductBannerProductCardSlotNames = [
  [
    "root",
    "mpb-product-card__root"
  ],
  [
    "highlightHeader",
    "mpb-product-card__highlightHeader"
  ],
  [
    "highlightHeaderInner",
    "mpb-product-card__highlightHeaderInner"
  ],
  [
    "highlightTextGroup",
    "mpb-product-card__highlightTextGroup"
  ],
  [
    "highlightText",
    "mpb-product-card__highlightText"
  ],
  [
    "highlightTooltipGroup",
    "mpb-product-card__highlightTooltipGroup"
  ],
  [
    "highlightTooltipIcon",
    "mpb-product-card__highlightTooltipIcon"
  ],
  [
    "highlightTooltipContent",
    "mpb-product-card__highlightTooltipContent"
  ],
  [
    "displayName",
    "mpb-product-card__displayName"
  ],
  [
    "displayNameText",
    "mpb-product-card__displayNameText"
  ],
  [
    "imageSection",
    "mpb-product-card__imageSection"
  ],
  [
    "imageWrapper",
    "mpb-product-card__imageWrapper"
  ],
  [
    "imageLink",
    "mpb-product-card__imageLink"
  ],
  [
    "imageContainer",
    "mpb-product-card__imageContainer"
  ],
  [
    "apySection",
    "mpb-product-card__apySection"
  ],
  [
    "apyValueRow",
    "mpb-product-card__apyValueRow"
  ],
  [
    "apyValueGroup",
    "mpb-product-card__apyValueGroup"
  ],
  [
    "apyValueText",
    "mpb-product-card__apyValueText"
  ],
  [
    "apyTooltipGroup",
    "mpb-product-card__apyTooltipGroup"
  ],
  [
    "apyTooltipIcon",
    "mpb-product-card__apyTooltipIcon"
  ],
  [
    "apyTooltipContent",
    "mpb-product-card__apyTooltipContent"
  ],
  [
    "apyDescription",
    "mpb-product-card__apyDescription"
  ],
  [
    "apyDescriptionText",
    "mpb-product-card__apyDescriptionText"
  ],
  [
    "apySpacer",
    "mpb-product-card__apySpacer"
  ],
  [
    "ctaSection",
    "mpb-product-card__ctaSection"
  ],
  [
    "ctaSubtextSection",
    "mpb-product-card__ctaSubtextSection"
  ],
  [
    "ctaSubtext",
    "mpb-product-card__ctaSubtext"
  ]
]
const multiProductBannerProductCardSlotFns = /* @__PURE__ */ multiProductBannerProductCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, multiProductBannerProductCardDefaultVariants, getSlotCompoundVariant(multiProductBannerProductCardCompoundVariants, slotName))])

const multiProductBannerProductCardFn = memo((props = {}) => {
  return Object.fromEntries(multiProductBannerProductCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const multiProductBannerProductCardVariantKeys = []
const getVariantProps = (variants) => ({ ...multiProductBannerProductCardDefaultVariants, ...compact(variants) })

export const multiProductBannerProductCard = /* @__PURE__ */ Object.assign(multiProductBannerProductCardFn, {
  __recipe__: false,
  __name__: 'multiProductBannerProductCard',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: multiProductBannerProductCardVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, multiProductBannerProductCardVariantKeys)
  },
  getVariantProps
})